/** Typ mustru pro další podpis ve stavebním deníku. */
export type DiaryAdditionalSignatureTemplate =
  | 'predani_povrchu'
  | 'predani_odpovednosti'
  | 'jine';

export const DIARY_SIGNATURE_TEMPLATE_OPTIONS: Array<{
  value: DiaryAdditionalSignatureTemplate;
  label: string;
}> = [
  { value: 'predani_povrchu', label: 'Předání povrchů' },
  { value: 'predani_odpovednosti', label: 'Předání odpovědnosti' },
  { value: 'jine', label: 'Jiné' },
];

export {
  buildPredaniPovrchuNote,
  buildPredaniOdpovednostiNote,
  diaryProtocolNoteStateOnOpen,
  formatPredaniLegalDate as formatDiaryLegalDate,
  formatPredaniZastupceLabel,
  shouldReplaceDiaryProtocolNote,
  type PredaniPovrchuNoteInput,
} from '@core/shared-bridge';
